<template>
  <div class="add-program-content">
    <el-form>
      <el-form-item :label="$t('screen.program_name')">
        <el-input
         :placeholder="$t('screen.please_program_name')"
          v-model="programItem.program_name"
        ></el-input>
      </el-form-item>
      <hr />
      <el-form-item
        :label="$t('lampStrategy.time_slot')"
        v-for="(item, index) in programItem.content"
        :key="item.key"
        :class="{
          crossed: item.crossed,
        }"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <el-slider
              range
              v-model="item.timeslots"
              :min="0"
              :max="86399"
              :step="900"
              @change="updateTime(item)"
              :format-tooltip="numberToTimeString"
            >
            </el-slider>
          </el-col>
          <el-col :span="4">
            <el-time-picker
              is-range
              v-model="item.timeslotsObj"
              @change="updateTimeNumber(item)"
              format="HH:mm"
              style="width: 100%"
            >
            </el-time-picker>
          </el-col>
          <el-col :span="3" align="right">{{$t('broadcast.select_media')}}</el-col>
          <el-col :span="4">
            <el-select
              filterable 
              :placeholder="$t('broadcast.select_media')"
              v-model="item.file"
              style="width: 100%"
            >
              <el-option
                v-for="t in mediaList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button class="remove" type="danger" @click="removeTime(index)"
              >{{$t('control.delete')}}</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addTime">{{$t('lampStrategy.add_time_slot')}}</el-button>
      </el-form-item>
      <hr />
      <div class="h10"></div>
      <div class="box-footer">
        <el-button
          type="primary"
          size="medium"
          native-type="submit"
          @click.prevent="addprogram"
          >{{$t('control.submit')}}</el-button
        >
        <el-button type="error"  size="medium"  @click="cancel">{{$t('control.cancel')}}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import time from "@/utils/time";
import moment from "moment";
import manageApi from "@/api/message/mediaManage"
import programApi from "@/api/message/programList"
export default {
  name: "addprogram",
  data() {
    return {
      crossed: false,
      programItem: {
        program_name: "",
        content: [],
      },
      mediaList: []
    };
  },
  methods: {
    ...time,
    updateTimeNumber(item) {
      this.checkValid();
      item.timeslots = [
        this.timeToNumber(item.timeslotsObj[0]),
        this.timeToNumber(item.timeslotsObj[1]),
      ];
    },
    updateTime(item) {
      this.checkValid();
      item.timeslotsObj = [
        this.numberToTime(item.timeslots[0]),
        this.numberToTime(item.timeslots[1]),
      ];
    },
    removeTime(index) {
      if (confirm(this.$t('lampStrategy.delect_time_table'))) {
        this.programItem.content.splice(index, 1);
        this.checkValid();
      }
    },
    addprogram() {
      let params = {
        program_name: this.programItem.program_name,
        time: "",
        file_id: ""
      }
      let status = "";
      let sfile = "";
      this.programItem.content
        .sort((x, y) => x.timeslotsObj[0] > y.timeslotsObj[0])
        .forEach((item, index) => {
          status +=
            [
              moment(item.timeslotsObj[0]).format("HH:mm") +
                "-" +
                moment(item.timeslotsObj[1]).format("HH:mm"),
            ] + ",";
          sfile += item.file + ",";
        });
      params.time = status.substring(0, status.length - 1);
      params.file_id = sfile.substring(0, sfile.length - 1);
      if (params.time === "") {
        this.$message.error(this.$t('lampStrategy.please_add_time_slot'));
      } else if (params.file_id === "") {
        this.$message.error(this.$t('broadcast.select_media'));
      } else {
        if (this.crossed) {
          this.$message.error(this.$t('lampStrategy.do_not_repeat'));
        } else {
          programApi.programAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.$emit('closeMethod')
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      }
    },
    addTime() {
      this.programItem.content.push({
        key: Date.now(),
        file: '',
        timeslots: [0, 3600],
        timeslotsObj: [this.numberToTime(0), this.numberToTime(3600)],
      });
      this.checkValid();
    },
    checkValid(change) {
      this.crossed = false;
      const cross = (s1, s2) => {
        return s2.timeslots[0] < s1.timeslots[1];
      };
      for (let i = 0; i < this.programItem.content.length; i++) {
        for (let j = i + 1; j < this.programItem.content.length; j++) {
          const s1 = this.programItem.content[i];
          const s2 = this.programItem.content[j];
          if (s1.timeslots[0] < s2.timeslots[0]) {
            this.crossed = cross(s1, s2);
          } else {
            this.crossed = cross(s2, s1);
          }
          if (this.crossed) {
            s1.crossed = true;
            s2.crossed = true;
            return;
          } else {
            s1.crossed = false;
            s2.crossed = false;
          }
        }
      }
    },
    cancel() {
      this.$emit('closeMethod')
    },
    getMediaList(pageIndex) {
       manageApi.manageList({
        page: pageIndex,
        pageSize: 2000,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.mediaList = resData.list;
          // console.log('this.mediaList',this.mediaList)
        }
      })
    }
  },
  mounted() {
    this.getMediaList(1)
  }
}
</script>

<style lang='less'>
.add-program-content{
  padding: 10px 20px;
  .crossed .el-form-item__label,
  .crossed .el-date-editor input,
  .crossed .el-date-editor .el-input__icon {
    color: #ff4949 !important;
  }
  .crossed .el-slider__button,
  .crossed .el-slider__bar {
    background: #ff4949 !important;
  }
  .crossed .el-slider__runway {
    background: #ffcdd2 !important;
  }
  .crossed .el-date-editor input {
    border-color: #ff4949 !important;
  }
}
</style>